import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ssoHandleCallback } from '@/shared/oidc';
import { setStoredUser, AuthUser } from '@/shared/auth';
import { Loader2, AlertTriangle } from 'lucide-react';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const u = await ssoHandleCallback();
        if (!u) {
          setError('Callback gagal — token tidak diterima');
          return;
        }
        const profile: any = u.profile || {};
        // Auto-provision di backend dgn /auth/dev-login (atau backend /me akan provision saat /me dipanggil pertama)
        const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8011';
        const resp = await fetch(`${apiUrl}/api/v1/auth/me`, {
          headers: { Authorization: `Bearer ${u.access_token}` },
        });
        if (resp.ok) {
          const me = await resp.json();
          const stored: AuthUser = {
            email: me.email,
            full_name: me.full_name,
            role: me.role,
            satker: me.satker || '',
            max_clearance: me.max_clearance,
            allowed_tabs: me.allowed_tabs || [],
          };
          setStoredUser(stored);
        } else {
          // fallback ke claims
          const stored: AuthUser = {
            email: profile.email || profile.preferred_username || 'unknown@kc',
            full_name: profile.name || profile.preferred_username || '—',
            role: profile.role || 'viewer',
            satker: profile.satker || 'polri_pusat',
            max_clearance: profile.max_clearance || 'BIASA',
          };
          setStoredUser(stored);
        }
        navigate('/', { replace: true });
      } catch (e: any) {
        setError(String(e?.message || e));
      }
    })();
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-paper">
      <div className="text-center max-w-md p-6">
        {error ? (
          <>
            <AlertTriangle className="w-12 h-12 text-crimson mx-auto mb-3" />
            <h1 className="font-display font-bold text-[18px] mb-2">SSO Callback Gagal</h1>
            <p className="font-mono text-[11px] text-crimson mb-4">{error}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="px-4 py-2 bg-ink text-paper hover:bg-brass font-mono text-[11px] uppercase tracking-wider"
            >
              Kembali ke Login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-brass mx-auto mb-3 animate-spin" />
            <p className="font-mono text-[11px] uppercase tracking-widest text-ink-2">
              Memverifikasi sesi Keycloak...
            </p>
          </>
        )}
      </div>
    </div>
  );
}
